/* eslint-disable no-magic-numbers */
/* eslint-disable @scandipwa/scandipwa-guidelines/only-render-in-component */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable max-len */
/* eslint-disable max-lines */
/**
 * ScandiPWA - Progressive Web App for Magento
 *
 * Copyright © Scandiweb, Inc. All rights reserved.
 * See LICENSE for license details.
 *
 * @license OSL-3.0 (Open Software License ("OSL") v. 3.0)
 * @package scandipwa/base-theme
 * @link https://github.com/scandipwa/base-theme
 */

import PropTypes from 'prop-types';
import { Component } from 'react';

import CmsBlock from 'Component/CmsBlock';
import ContentWrapper from 'Component/ContentWrapper';
import Image from 'Component/Image';
import Link from 'Component/Link';
import NewsletterSubscription from 'Component/NewsletterSubscription';
// import ChevronIconComponent from 'Component/ChevronIcon';
import PlpFooter from 'Component/PlpFooter';
// import Html from 'SourceComponent/Html';
import { DeviceType } from 'Type/Device.type';
import { noopFn } from 'Util/Common';

import {
    COLUMN_MAP,
    // NEWSLETTER_COLUMN,
    RENDER_NEWSLETTER
} from './Footer.config';

import './Footer.style';

/**
 * Page footer
 * @class Footer
 * @namespace Scandi/Component/Footer/Component */
export class FooterComponent extends Component {
    static propTypes = {
        copyright: PropTypes.string,
        isVisibleOnMobile: PropTypes.bool,
        device: DeviceType.isRequired,
        newsletterActive: PropTypes.bool.isRequired,
        onItemClick: PropTypes.func,
        onClickFooterAccordion: PropTypes.func.isRequired,
        isPLP: PropTypes.bool.isRequired,
        mobileFooterCollapse: PropTypes.bool.isRequired
    };

    static defaultProps = {
        copyright: '',
        isVisibleOnMobile: false,
        onItemClick: noopFn
    };

    renderMap = {
        [RENDER_NEWSLETTER]: {
            render: this.renderNewsletterSubscriptionBlock.bind(this)
        }
    };

    shouldComponentUpdate(nextProps) {
        const {
            device: {
                isMobile
            },
            isVisibleOnMobile,
            copyright,
            newsletterActive,
            mobileFooterCollapse,
            isPLP
        } = this.props;

        const {
            device: {
                isMobile: nextIsMobile
            },
            isVisibleOnMobile: nextIsVisibleOnMobile,
            copyright: nextCopyright,
            newsletterActive: nextNewsletterActive,
            mobileFooterCollapse: nextmobileFooterCollapse,
            isPLP: nextIsPLP
        } = nextProps;

        return isMobile !== nextIsMobile
            || isVisibleOnMobile !== nextIsVisibleOnMobile
            || copyright !== nextCopyright
            || newsletterActive !== nextNewsletterActive
            || mobileFooterCollapse !== nextmobileFooterCollapse
            || isPLP !== nextIsPLP;
    }

    renderColumnItemContent(src, title) {
        if (!src) {
            return title;
        }

        return (
            <Image
              mix={ { block: 'Footer', elem: 'ColumnItemImage' } }
              src={ src }
            />
        );
    }

    renderColumnItemLink({ to = '/', title, src }, i) {
        const mods = src ? { type: 'image' } : {};
        const { onItemClick } = this.props;

        return (
            <Link
              block="Footer"
              elem="ColumnItem"
              to={ to }
              mods={ mods }
              key={ i }
              aria-label={ title }
              onClick={ onItemClick }
            >
                { this.renderColumnItemContent(src, title) }
            </Link>
        );
    }

    renderColumnItem(item, i) {
        const { render } = item;

        if (render) {
            return this.renderMap[render].render(item, i);
        }

        return this.renderColumnItemLink(item, i);
    }

    renderColumn(column, i) {
        const {
            title,
            columnActiveKey,
            items,
            isItemsHorizontal,
            mods = {}
        } = column;

        const contentMods = isItemsHorizontal ? { direction: 'horizontal' } : {};

        const { [columnActiveKey]: isColumnActive } = this.props;

        if (columnActiveKey && !isColumnActive === true) {
            return null;
        }

        return (
            <div block="Footer" elem="Column" mods={ mods } key={ i }>
                <h3 block="Footer" elem="ColumnTitle">
                    { title }
                </h3>
                <div
                  block="Footer"
                  elem="ColumnContent"
                  mods={ contentMods }
                >
                    { items.map(this.renderColumnItem.bind(this)) }
                </div>
            </div>
        );
    }

    renderColumns() {
        return (
            <ContentWrapper
              isNotSection
              wrapperMix={ { block: 'Footer', elem: 'Columns' } }
              label=""
            >
                { COLUMN_MAP.map(this.renderColumn.bind(this)) }
            </ContentWrapper>
        );
    }

    renderNewsletterSubscriptionBlock() {
        return <NewsletterSubscription key="NewsletterSubscription" />;
    }

    renderCmsBlockWrapper() {
        const { footer_content: { footer_cms } = {} } = window.contentConfiguration;

        return (
            <div
              block="Footer"
              elem="CmsBlockWrapper"
            >
                <div
                  block="Footer"
                  elem="Columns"
                  mix={ { block: 'ContentWrapper' } }
                >
                    <CmsBlock identifier={ footer_cms } />
                </div>
            </div>
        );
    }

    renderContent() {
        // const { footer_content: { footer_cms } = {} } = window.contentConfiguration;
        /* if (footer_cms) {
            return (
                <footer block="Footer" aria-label="Footer">
                    { this.renderCmsBlockWrapper() }
                </footer>
            );
        } */

        return (
            <footer block="Footer" aria-label="Footer">
                <div class="Footer-Columns" style={ { flexDirection: 'column' } }>
                    <div class="Footer-Column-Center">
                        <div class="Footer-Columns">
                            <div class="Footer-Column">
                                <h3 class="Footer-ColumnTitle">Company</h3>
                                <div class="Footer-ColumnContent">
                                    <Link class="Footer-ColumnItem" to="/">
                                        Who are we?
                                    </Link>
                                    <Link class="Footer-ColumnItem" to="/">
                                        Careers
                                    </Link>
                                    <Link class="Footer-ColumnItem" to="/">
                                        Authenticity
                                    </Link>
                                    <Link class="Footer-ColumnItem" to="/">
                                        Press
                                    </Link>
                                    <Link class="Footer-ColumnItem" to="/">
                                        Testimonials
                                    </Link>
                                    <Link class="Footer-ColumnItem" to="/">
                                        ZM CSR
                                    </Link>
                                    <Link class="Footer-ColumnItem" to="/">
                                        Responsible Disclosure
                                    </Link>
                                    <Link class="Footer-ColumnItem" to="/">
                                        Investor Relations
                                    </Link>
                                </div>
                            </div>
                            <div class="Footer-Column">
                                <h3 class="Footer-ColumnTitle">Help</h3>
                                <div class="Footer-ColumnContent">
                                    <Link class="Footer-ColumnItem" to="/contact">
                                        Contact Us
                                    </Link>
                                    <Link class="Footer-ColumnItem" to="/">
                                        Frequently asked questions
                                    </Link>
                                    <Link class="Footer-ColumnItem" to="/">
                                        Store Locator
                                    </Link>
                                    <Link class="Footer-ColumnItem" to="/">
                                        Cancellation & Return
                                    </Link>
                                    <Link class="Footer-ColumnItem" to="/">
                                        Shipping & Delivery
                                    </Link>
                                    <Link class="Footer-ColumnItem" to="/">
                                        Sell on ZM
                                    </Link>
                                </div>
                            </div>
                            <div class="Footer-Column">
                                <h3 class="Footer-ColumnTitle">Inspire me</h3>
                                <div class="Footer-ColumnContent">
                                    <Link class="Footer-ColumnItem" to="/">
                                        Beauty Book
                                    </Link>
                                    <Link class="Footer-ColumnItem" to="/">
                                        ZM TV
                                    </Link>
                                    <Link class="Footer-ColumnItem" to="/">
                                        ZM Network
                                    </Link>
                                    <Link class="Footer-ColumnItem" to="/">
                                        Buying Guides
                                    </Link>
                                </div>
                            </div>
                            <div class="Footer-Column">
                                <h3 class="Footer-ColumnTitle">Top Categories</h3>
                                <div class="Footer-ColumnContent">
                                    <Link class="Footer-ColumnItem" to="/">
                                        Makeup
                                    </Link>
                                    <Link class="Footer-ColumnItem" to="/">
                                        Skin
                                    </Link>
                                    <Link class="Footer-ColumnItem" to="/">
                                        Hair
                                    </Link>
                                    <Link class="Footer-ColumnItem" to="/">
                                        Bath & Body
                                    </Link>
                                    <Link class="Footer-ColumnItem" to="/">
                                        Appliances
                                    </Link>
                                    <Link class="Footer-ColumnItem" to="/">
                                        Mom and Baby
                                    </Link>
                                    <Link class="Footer-ColumnItem" to="/">
                                        Wellness
                                    </Link>
                                    <Link class="Footer-ColumnItem" to="/">
                                        Fragrance
                                    </Link>
                                    <Link class="Footer-ColumnItem" to="/">
                                        Natural Luxe
                                    </Link>
                                </div>
                            </div>
                            <div class="Footer-Column">
                                <h3 class="Footer-ColumnTitle">Account</h3>
                                <div class="Footer-ColumnContent">
                                    <Link class="Footer-ColumnItem" to="/contact">
                                        My Orders
                                    </Link>
                                    <Link class="Footer-ColumnItem" to="/">
                                        My Wishlist
                                    </Link>
                                    <Link class="Footer-ColumnItem" to="/">
                                        My Addresses
                                    </Link>
                                    <Link class="Footer-ColumnItem" to="/">
                                        My Account
                                    </Link>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="Footer-Columns-Bottom">
                        <div class="Footer-Column-Left">
                            <div class="Footer-Column">
                                <h3 class="Footer-ColumnTitle">
                                <span className="Footer-ColumnTitle-Title">
                                    <svg width="14px" height="14px" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M2 6C2 4.89543 2.89543 4 4 4H20C21.1046 4 22 4.89543 22 6V18C22 19.1046 21.1046 20 20 20H4C2.89543 20 2 19.1046 2 18V6Z" stroke="#8B8B8B" strokeWidth="2" />
                                        <path d="M2 4L9.50122 14.001C10.9621 15.1697 13.0379 15.1697 14.4988 14.001L22 4" stroke="#8B8B8B" fill="#8B8B8B" strokeWidth="2" />
                                    </svg>
                                    { '   ' }
                                    Get special discount on your inbox
                                </span>
                                </h3>
                                <div class="Footer-ColumnContent">
                                    <form className="news-Wrap">
                                        <input
                                          className="news-Input"
                                          aria-label="Enter your mail id"
                                          name="email_address"
                                          placeholder="Enter your mail id"
                                          required
                                          type="email"
                                        />
                                        <button className="news-Button">Send</button>
                                    </form>
                                </div>
                            </div>
                        </div>
                        <div class="Footer-Column-right">
                            <div class="Footer-Column">
                                <h3 class="Footer-ColumnTitle">
                                    <span className="Footer-ColumnTitle-Title">
                                        Show us some
                                        { ' ' }
                                        <svg width="14px" height="14px" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                                        <g transform="translate(0 -1028.4)">
                                            <path d="m7 1031.4c-1.5355 0-3.0784 0.5-4.25 1.7-2.3431 2.4-2.2788 6.1 0 8.5l9.25 9.8 9.25-9.8c2.279-2.4 2.343-6.1 0-8.5-2.343-2.3-6.157-2.3-8.5 0l-0.75 0.8-0.75-0.8c-1.172-1.2-2.7145-1.7-4.25-1.7z" fill="#e74c3c" />
                                        </g>
                                        </svg>
                                        { ' ' }
                                        on social media
                                    </span>
                                </h3>
                                <div class="Footer-ColumnContent">
                                    <div class="Footer-ColumnContent-Icons">
                                        <Link to="/">
                                            <svg width="20px" height="20px" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path fill-rule="evenodd" clip-rule="evenodd" d="M3 11C3 7.22876 3 5.34315 4.17157 4.17157C5.34315 3 7.22876 3 11 3H13C16.7712 3 18.6569 3 19.8284 4.17157C21 5.34315 21 7.22876 21 11V13C21 16.7712 21 18.6569 19.8284 19.8284C18.6569 21 16.7712 21 13 21H11C7.22876 21 5.34315 21 4.17157 19.8284C3 18.6569 3 16.7712 3 13V11ZM18 7.5C18 8.32843 17.3284 9 16.5 9C15.6716 9 15 8.32843 15 7.5C15 6.67157 15.6716 6 16.5 6C17.3284 6 18 6.67157 18 7.5ZM14 13C14 14.1046 13.1046 15 12 15C10.8954 15 10 14.1046 10 13C10 11.8954 10.8954 11 12 11C13.1046 11 14 11.8954 14 13ZM16 13C16 15.2091 14.2091 17 12 17C9.79086 17 8 15.2091 8 13C8 10.7909 9.79086 9 12 9C14.2091 9 16 10.7909 16 13Z" fill="#8B8B8B" />
                                            </svg>
                                        </Link>
                                        <Link to="/">
                                            <svg fill="#8B8B8B" width="20px" height="20px" viewBox="-7 -2 24 24" xmlns="http://www.w3.org/2000/svg">
                                                <path d="M2.046 3.865v2.748H.032v3.36h2.014v9.986H6.18V9.974h2.775s.26-1.611.386-3.373H6.197V4.303c0-.343.45-.805.896-.805h2.254V0H6.283c-4.34 0-4.237 3.363-4.237 3.865z" />
                                            </svg>
                                        </Link>
                                        <Link to="/">
                                            <svg fill="#8B8B8B" width="20px" height="20px" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                                                <path d="M22,5.8a8.49,8.49,0,0,1-2.36.64,4.13,4.13,0,0,0,1.81-2.27,8.21,8.21,0,0,1-2.61,1,4.1,4.1,0,0,0-7,3.74A11.64,11.64,0,0,1,3.39,4.62a4.16,4.16,0,0,0-.55,2.07A4.09,4.09,0,0,0,4.66,10.1,4.05,4.05,0,0,1,2.8,9.59v.05a4.1,4.1,0,0,0,3.3,4A3.93,3.93,0,0,1,5,13.81a4.9,4.9,0,0,1-.77-.07,4.11,4.11,0,0,0,3.83,2.84A8.22,8.22,0,0,1,3,18.34a7.93,7.93,0,0,1-1-.06,11.57,11.57,0,0,0,6.29,1.85A11.59,11.59,0,0,0,20,8.45c0-.17,0-.35,0-.53A8.43,8.43,0,0,0,22,5.8Z" />
                                            </svg>
                                        </Link>
                                        <Link to="/">
                                            <svg fill="#8B8B8B" width="20px" height="20px" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                                                <path d="M23,9.71a8.5,8.5,0,0,0-.91-4.13,2.92,2.92,0,0,0-1.72-1A78.36,78.36,0,0,0,12,4.27a78.45,78.45,0,0,0-8.34.3,2.87,2.87,0,0,0-1.46.74c-.9.83-1,2.25-1.1,3.45a48.29,48.29,0,0,0,0,6.48,9.55,9.55,0,0,0,.3,2,3.14,3.14,0,0,0,.71,1.36,2.86,2.86,0,0,0,1.49.78,45.18,45.18,0,0,0,6.5.33c3.5.05,6.57,0,10.2-.28a2.88,2.88,0,0,0,1.53-.78,2.49,2.49,0,0,0,.61-1,10.58,10.58,0,0,0,.52-3.4C23,13.69,23,10.31,23,9.71ZM9.74,14.85V8.66l5.92,3.11C14,12.69,11.81,13.73,9.74,14.85Z" />
                                            </svg>
                                        </Link>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </footer>
        );
    }

    renderCopyrightContent() {
        const { copyright } = this.props;

        return (
            <ContentWrapper
              mix={ { block: 'Footer', elem: 'CopyrightContentWrapper' } }
              wrapperMix={ { block: 'Footer', elem: 'CopyrightContent' } }
              label=""
            >
                <span block="Footer" elem="Copyright">
                    { copyright }
                    { ' Powered by ' }
                    { /* eslint-disable-next-line react/forbid-elements */ }
                    <Link to="https://scandipwa.com">
                        ScandiPWA
                    </Link>
                </span>
            </ContentWrapper>
        );
    }

    renderBanner() {
        const { device: { isMobile } } = this.props;
        // eslint-disable-next-line fp/no-let
        let firstImg = {};
        if (isMobile) {
            firstImg = {
                imgPath: 'https://www.zaynmyza.com/media/new_zm/mobile_1.webp',
                label: 'Skin Analyser'
            };
        } else {
            firstImg = {
                imgPath: 'https://www.zaynmyza.com/media/new_zm/desktop_1.webp',
                label: 'Skin Analyser'
            };
        }

        return (
            <div block="HomeBanner">
                <img loading="lazy" src={ firstImg.imgPath } alt={ firstImg.label } />
            </div>
        );
    }

    renderLastLine() {
        const { device: { isMobile } } = this.props;
        if (isMobile) {
            return null;
        }

        return (
            <section block="LastLine">
                <div block="LastLine" elem="wrap">
                    <div className="LastLine-Container">
                        <svg width="80" height="80" viewBox="0 0 80 80" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M26.0047 12.7743C29.4299 14.2315 33.405 12.9398 35.3196 9.74771C37.4392 6.21372 42.5608 6.21372 44.6804 9.74771C46.595 12.9398 50.5701 14.2315 53.9953 12.7743C57.7874 11.1611 61.9308 14.1715 61.5684 18.2764C61.241 21.9843 63.6978 25.3658 67.3253 26.2002C71.3413 27.124 72.924 31.9949 70.2179 35.1028C67.7737 37.9101 67.7737 42.0899 70.2179 44.8972C72.924 48.0051 71.3413 52.876 67.3253 53.7998C63.6978 54.6342 61.241 58.0157 61.5684 61.7236C61.9308 65.8285 57.7874 68.8389 53.9953 67.2257C50.5701 65.7685 46.595 67.0602 44.6804 70.2523C42.5608 73.7863 37.4392 73.7863 35.3196 70.2523C33.405 67.0602 29.4299 65.7685 26.0047 67.2257C22.2126 68.8389 18.0692 65.8285 18.4316 61.7236C18.759 58.0157 16.3022 54.6342 12.6747 53.7998C8.65866 52.876 7.07602 48.0051 9.78205 44.8972C12.2263 42.0899 12.2263 37.9101 9.78205 35.1028C7.07602 31.9949 8.65866 27.124 12.6747 26.2002C16.3022 25.3658 18.759 21.9843 18.4316 18.2764C18.0692 14.1715 22.2126 11.1611 26.0047 12.7743Z" fill="white" stroke="#ddbbb9" strokeWidth="2" />
                        <g clip-path="url(#clip0_1_261)">
                        <path d="M55 38.9875V38.9625C55.002 38.9328 54.9978 38.903 54.9875 38.875V38.8375C54.9875 38.8125 54.975 38.7875 54.975 38.7625V38.7375L54.95 38.6375H54.9375L53.1875 34.2875C53.0481 33.9068 52.7942 33.5786 52.4606 33.3481C52.1271 33.1175 51.7304 32.9959 51.325 33H47V32C47 31.7348 46.8946 31.4804 46.7071 31.2929C46.5196 31.1054 46.2652 31 46 31H27C26.4696 31 25.9609 31.2107 25.5858 31.5858C25.2107 31.9609 25 32.4696 25 33V47C25 47.5304 25.2107 48.0391 25.5858 48.4142C25.9609 48.7893 26.4696 49 27 49H28.625C28.8453 49.8604 29.3457 50.623 30.0473 51.1676C30.7489 51.7122 31.6118 52.0078 32.5 52.0078C33.3882 52.0078 34.2511 51.7122 34.9527 51.1676C35.6543 50.623 36.1547 49.8604 36.375 49H43.625C43.8453 49.8604 44.3457 50.623 45.0473 51.1676C45.7489 51.7122 46.6118 52.0078 47.5 52.0078C48.3882 52.0078 49.2511 51.7122 49.9527 51.1676C50.6543 50.623 51.1547 49.8604 51.375 49H53C53.5304 49 54.0391 48.7893 54.4142 48.4142C54.7893 48.0391 55 47.5304 55 47V39V38.9875ZM47 35H51.325L52.525 38H47V35ZM27 33H45V41H27V33ZM32.5 50C32.1044 50 31.7178 49.8827 31.3889 49.6629C31.06 49.4432 30.8036 49.1308 30.6522 48.7654C30.5009 48.3999 30.4613 47.9978 30.5384 47.6098C30.6156 47.2219 30.8061 46.8655 31.0858 46.5858C31.3655 46.3061 31.7219 46.1156 32.1098 46.0384C32.4978 45.9613 32.8999 46.0009 33.2654 46.1522C33.6308 46.3036 33.9432 46.56 34.1629 46.8889C34.3827 47.2178 34.5 47.6044 34.5 48C34.5 48.5304 34.2893 49.0391 33.9142 49.4142C33.5391 49.7893 33.0304 50 32.5 50ZM47.5 50C47.1044 50 46.7178 49.8827 46.3889 49.6629C46.06 49.4432 45.8036 49.1308 45.6522 48.7654C45.5009 48.3999 45.4613 47.9978 45.5384 47.6098C45.6156 47.2219 45.8061 46.8655 46.0858 46.5858C46.3655 46.3061 46.7219 46.1156 47.1098 46.0384C47.4978 45.9613 47.8999 46.0009 48.2654 46.1522C48.6308 46.3036 48.9432 46.56 49.1629 46.8889C49.3827 47.2178 49.5 47.6044 49.5 48C49.5 48.5304 49.2893 49.0391 48.9142 49.4142C48.5391 49.7893 48.0304 50 47.5 50Z" fill="#DE4D47" />
                        </g>
                        <defs>
                        <clipPath id="clip0_1_261">
                        <rect width="32" height="32" fill="white" transform="translate(24 24)" />
                        </clipPath>
                        </defs>
                        </svg>
                        <div className="LastLine-Name">
                            <span className="LastLine-Title">Free Shipping</span>
                            <span className="LastLine-Text">Above Rs 499</span>
                        </div>
                    </div>
                    <div className="LastLine-Container">
                        <svg width="80" height="80" viewBox="0 0 80 80" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M26.0047 12.7743C29.4299 14.2315 33.405 12.9398 35.3196 9.74771C37.4392 6.21372 42.5608 6.21372 44.6804 9.74771C46.595 12.9398 50.5701 14.2315 53.9953 12.7743C57.7874 11.1611 61.9308 14.1715 61.5684 18.2764C61.241 21.9843 63.6978 25.3658 67.3253 26.2002C71.3413 27.124 72.924 31.9949 70.2179 35.1028C67.7737 37.9101 67.7737 42.0899 70.2179 44.8972C72.924 48.0051 71.3413 52.876 67.3253 53.7998C63.6978 54.6342 61.241 58.0157 61.5684 61.7236C61.9308 65.8285 57.7874 68.8389 53.9953 67.2257C50.5701 65.7685 46.595 67.0602 44.6804 70.2523C42.5608 73.7863 37.4392 73.7863 35.3196 70.2523C33.405 67.0602 29.4299 65.7685 26.0047 67.2257C22.2126 68.8389 18.0692 65.8285 18.4316 61.7236C18.759 58.0157 16.3022 54.6342 12.6747 53.7998C8.65866 52.876 7.07602 48.0051 9.78205 44.8972C12.2263 42.0899 12.2263 37.9101 9.78205 35.1028C7.07602 31.9949 8.65866 27.124 12.6747 26.2002C16.3022 25.3658 18.759 21.9843 18.4316 18.2764C18.0692 14.1715 22.2126 11.1611 26.0047 12.7743Z" fill="white" stroke="#ddbbb9" strokeWidth="2" />
                        <g clip-path="url(#clip0_1_271)">
                        <path d="M53.7375 33.8499C53.7342 33.8499 53.731 33.8486 53.7287 33.8463C53.7263 33.8439 53.725 33.8408 53.725 33.8374C53.5443 33.5298 53.2856 33.2754 52.975 33.0999L41.975 26.9124C41.677 26.746 41.3413 26.6587 41 26.6587C40.6587 26.6587 40.323 26.746 40.025 26.9124L29.025 33.0999C28.7144 33.2754 28.4557 33.5298 28.275 33.8374C28.275 33.8408 28.2737 33.8439 28.2713 33.8463C28.269 33.8486 28.2658 33.8499 28.2625 33.8499V33.8749C28.0897 34.1662 27.999 34.4988 28 34.8374V47.1624C28.0006 47.5188 28.0959 47.8685 28.2759 48.176C28.456 48.4835 28.7145 48.7376 29.025 48.9124L40.025 55.0999C40.3019 55.251 40.6098 55.3365 40.925 55.3499H41.1C41.4072 55.3363 41.7069 55.2507 41.975 55.0999L52.975 48.9124C53.2855 48.7376 53.544 48.4835 53.7241 48.176C53.9041 47.8685 53.9994 47.5188 54 47.1624V34.8374C54.0018 34.4908 53.9112 34.1499 53.7375 33.8499ZM41 28.6499L50.9625 34.2499L47.1375 36.4249L37.05 30.8624L41 28.6499ZM41.1125 39.8499L31.05 34.2499L35 32.0249L45.1 37.5874L41.1125 39.8499ZM42.0125 52.7874L42.1125 41.5874L46.125 39.2999V44.0624C46.125 44.3277 46.2304 44.582 46.4179 44.7696C46.6054 44.9571 46.8598 45.0624 47.125 45.0624C47.3902 45.0624 47.6446 44.9571 47.8321 44.7696C48.0196 44.582 48.125 44.3277 48.125 44.0624V38.1624L52 35.9624V47.1624L42.0125 52.7874Z" fill="#DE4D47" />
                        </g>
                        <defs>
                        <clipPath id="clip0_1_271">
                        <rect width="32" height="32" fill="white" transform="translate(25 25)" />
                        </clipPath>
                        </defs>
                        </svg>
                        <div className="LastLine-Name">
                            <span className="LastLine-Title">Easy Return</span>
                            <span className="LastLine-Text">15 Days</span>
                        </div>
                    </div>
                    <div className="LastLine-Container">
                        <svg width="80" height="80" viewBox="0 0 80 80" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M26.0047 12.7743C29.4299 14.2315 33.405 12.9398 35.3196 9.74771C37.4392 6.21372 42.5608 6.21372 44.6804 9.74771C46.595 12.9398 50.5701 14.2315 53.9953 12.7743C57.7874 11.1611 61.9308 14.1715 61.5684 18.2764C61.241 21.9843 63.6978 25.3658 67.3253 26.2002C71.3413 27.124 72.924 31.9949 70.2179 35.1028C67.7737 37.9101 67.7737 42.0899 70.2179 44.8972C72.924 48.0051 71.3413 52.876 67.3253 53.7998C63.6978 54.6342 61.241 58.0157 61.5684 61.7236C61.9308 65.8285 57.7874 68.8389 53.9953 67.2257C50.5701 65.7685 46.595 67.0602 44.6804 70.2523C42.5608 73.7863 37.4392 73.7863 35.3196 70.2523C33.405 67.0602 29.4299 65.7685 26.0047 67.2257C22.2126 68.8389 18.0692 65.8285 18.4316 61.7236C18.759 58.0157 16.3022 54.6342 12.6747 53.7998C8.65866 52.876 7.07602 48.0051 9.78205 44.8972C12.2263 42.0899 12.2263 37.9101 9.78205 35.1028C7.07602 31.9949 8.65866 27.124 12.6747 26.2002C16.3022 25.3658 18.759 21.9843 18.4316 18.2764C18.0692 14.1715 22.2126 11.1611 26.0047 12.7743Z" fill="white" stroke="#ddbbb9" strokeWidth="2" />
                        <g clip-path="url(#clip0_1_281)">
                        <path d="M50.4032 43.1772C50.4062 43.5874 50.2814 43.9883 50.0462 44.3242C49.811 44.6602 49.4771 44.9147 49.0907 45.0522L42.5657 47.4522L40.1657 53.9772C40.0236 54.36 39.7678 54.6901 39.4327 54.9232C39.0975 55.1563 38.699 55.2813 38.2907 55.2813C37.8824 55.2813 37.4839 55.1563 37.1488 54.9232C36.8136 54.6901 36.5578 54.36 36.4157 53.9772L34.0157 47.4522L27.4907 45.0522C27.108 44.9102 26.7778 44.6544 26.5447 44.3192C26.3116 43.984 26.1867 43.5855 26.1867 43.1772C26.1867 42.769 26.3116 42.3705 26.5447 42.0353C26.7778 41.7001 27.108 41.4443 27.4907 41.3022L34.0157 38.9022L36.4157 32.3772C36.5578 31.9945 36.8136 31.6644 37.1488 31.4313C37.4839 31.1982 37.8824 31.0732 38.2907 31.0732C38.699 31.0732 39.0975 31.1982 39.4327 31.4313C39.7678 31.6644 40.0236 31.9945 40.1657 32.3772L42.5657 38.9022L49.0907 41.3022C49.4771 41.4398 49.811 41.6943 50.0462 42.0302C50.2814 42.3662 50.4062 42.7671 50.4032 43.1772ZM43.2907 31.1772H45.2907V33.1772C45.2907 33.4425 45.3961 33.6968 45.5836 33.8844C45.7711 34.0719 46.0255 34.1772 46.2907 34.1772C46.5559 34.1772 46.8103 34.0719 46.9978 33.8844C47.1854 33.6968 47.2907 33.4425 47.2907 33.1772V31.1772H49.2907C49.5559 31.1772 49.8103 31.0719 49.9978 30.8844C50.1854 30.6968 50.2907 30.4425 50.2907 30.1772C50.2907 29.912 50.1854 29.6577 49.9978 29.4701C49.8103 29.2826 49.5559 29.1772 49.2907 29.1772H47.2907V27.1772C47.2907 26.912 47.1854 26.6577 46.9978 26.4701C46.8103 26.2826 46.5559 26.1772 46.2907 26.1772C46.0255 26.1772 45.7711 26.2826 45.5836 26.4701C45.3961 26.6577 45.2907 26.912 45.2907 27.1772V29.1772H43.2907C43.0255 29.1772 42.7711 29.2826 42.5836 29.4701C42.3961 29.6577 42.2907 29.912 42.2907 30.1772C42.2907 30.4425 42.3961 30.6968 42.5836 30.8844C42.7711 31.0719 43.0255 31.1772 43.2907 31.1772ZM54.2907 35.1772H53.2907V34.1772C53.2907 33.912 53.1854 33.6577 52.9978 33.4701C52.8103 33.2826 52.5559 33.1772 52.2907 33.1772C52.0255 33.1772 51.7711 33.2826 51.5836 33.4701C51.3961 33.6577 51.2907 33.912 51.2907 34.1772V35.1772H50.2907C50.0255 35.1772 49.7711 35.2826 49.5836 35.4701C49.3961 35.6577 49.2907 35.912 49.2907 36.1772C49.2907 36.4425 49.3961 36.6968 49.5836 36.8844C49.7711 37.0719 50.0255 37.1772 50.2907 37.1772H51.2907V38.1772C51.2907 38.4425 51.3961 38.6968 51.5836 38.8844C51.7711 39.0719 52.0255 39.1772 52.2907 39.1772C52.5559 39.1772 52.8103 39.0719 52.9978 38.8844C53.1854 38.6968 53.2907 38.4425 53.2907 38.1772V37.1772H54.2907C54.5559 37.1772 54.8103 37.0719 54.9978 36.8844C55.1854 36.6968 55.2907 36.4425 55.2907 36.1772C55.2907 35.912 55.1854 35.6577 54.9978 35.4701C54.8103 35.2826 54.5559 35.1772 54.2907 35.1772Z" fill="#DE4D47" />
                        </g>
                        <defs>
                        <clipPath id="clip0_1_281">
                        <rect width="32" height="32" fill="white" transform="translate(24.2907 25.1772)" />
                        </clipPath>
                        </defs>
                        </svg>
                        <div className="LastLine-Name">
                            <span className="LastLine-Title">100% Authentic</span>
                            <span className="LastLine-Text">Genuine Products</span>
                        </div>
                    </div>
                    <div className="LastLine-Container">
                        <svg width="80" height="80" viewBox="0 0 80 80" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M26.0047 12.7743C29.4299 14.2315 33.405 12.9398 35.3196 9.74771C37.4392 6.21372 42.5608 6.21372 44.6804 9.74771C46.595 12.9398 50.5701 14.2315 53.9953 12.7743C57.7874 11.1611 61.9308 14.1715 61.5684 18.2764C61.241 21.9843 63.6978 25.3658 67.3253 26.2002C71.3413 27.124 72.924 31.9949 70.2179 35.1028C67.7737 37.9101 67.7737 42.0899 70.2179 44.8972C72.924 48.0051 71.3413 52.876 67.3253 53.7998C63.6978 54.6342 61.241 58.0157 61.5684 61.7236C61.9308 65.8285 57.7874 68.8389 53.9953 67.2257C50.5701 65.7685 46.595 67.0602 44.6804 70.2523C42.5608 73.7863 37.4392 73.7863 35.3196 70.2523C33.405 67.0602 29.4299 65.7685 26.0047 67.2257C22.2126 68.8389 18.0692 65.8285 18.4316 61.7236C18.759 58.0157 16.3022 54.6342 12.6747 53.7998C8.65866 52.876 7.07602 48.0051 9.78205 44.8972C12.2263 42.0899 12.2263 37.9101 9.78205 35.1028C7.07602 31.9949 8.65866 27.124 12.6747 26.2002C16.3022 25.3658 18.759 21.9843 18.4316 18.2764C18.0692 14.1715 22.2126 11.1611 26.0047 12.7743Z" fill="white" stroke="#ddbbb9" strokeWidth="2" />
                        <g clip-path="url(#clip0_1_291)">
                        <path d="M42.4164 29.8042V52.0013C42.4164 54.2095 44.2066 55.9998 46.4148 55.9998H49.8679C52.0761 55.9998 53.8664 54.2096 53.8664 52.0013V29.8042H42.4164Z" fill="#DE4D47" />
                        <path d="M34.8192 32.2266V25.8219L28.898 24V32.2266H27.5656V35.8261H36.1516V32.2266H34.8192Z" fill="#DE4D47" />
                        <path d="M26.1336 37.9131V52.0016C26.1336 54.2098 27.9238 56.0001 30.1321 56.0001H33.5852C35.7934 56.0001 37.5836 54.2099 37.5836 52.0016V37.9131H26.1336Z" fill="#DE4D47" />
                        </g>
                        <defs>
                        <clipPath id="clip0_1_291">
                        <rect width="32" height="32" fill="white" transform="translate(24 24)" />
                        </clipPath>
                        </defs>
                        </svg>
                        <div className="LastLine-Name">
                            <span className="LastLine-Title">2100+ Brands</span>
                            <span className="LastLine-Text">1.3L Products</span>
                        </div>
                    </div>
                </div>
            </section>
        );
    }

    renderPlpFooter() {
        const { isPLP } = this.props;

        if (!isPLP) {
            return null;
        }

        return <PlpFooter />;
    }

    renderCMSBanners() {
        const { footer_content: { footer_banners } = {} } = window.contentConfiguration;

        return (
            <CmsBlock identifier={ footer_banners } />
        );
    }

    renderMobileFooter() {
        const { mobileFooterCollapse, onClickFooterAccordion } = this.props;
        return (
            <div block="Footer" elem="Mobile" mods={ { isOpen: mobileFooterCollapse } }>
                <div
                  block="Footer"
                  elem="MobileToggle"
                  onClick={ onClickFooterAccordion }
                  key="Footer-Toggle"
                >
                    <span>More About Online Shopping at ZAYNMYZA</span>
                    <span block="Footer" elem="Caret" mods={ { isOpen: mobileFooterCollapse } }>
                    <svg width="14px" height="14px" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
                        <path fill="#fff" fill-rule="evenodd" d="M7.05307007,2.15808105 L14.2962587,9.41418482 C14.4320862,9.5496827 14.5,9.71077067 14.5,9.89744874 C14.5,10.0841268 14.4320862,10.2497803 14.2962587,10.3944092 C11.6760845,12.9498393 9.15095523,15.4168071 6.72087106,17.7953128 C6.5962677,17.912323 6.09560574,18.2032928 5.70989407,17.7705688 C5.3241824,17.3378448 5.55848694,16.9602509 5.70989407,16.8045692 C7.97174895,14.594209 10.3279004,12.2918355 12.7783485,9.89744874 L6.03100586,3.13816833 C5.78524099,2.79925826 5.80526899,2.48632792 6.09108986,2.19937732 C6.37691073,1.91242672 6.6975708,1.8986613 7.05307007,2.15808105 Z" />
                    </svg>
                    </span>
                </div>
                { mobileFooterCollapse ? this.renderContent() : null }
            </div>
        );
    }

    renderBackup() {
        const { isVisibleOnMobile, device, isPLP } = this.props;
        if (!isVisibleOnMobile && device.isMobile) {
            return null;
        }

        if (device.isMobile) {
            return this.renderMobileFooter();
        }

        return (
            <>
            { this.renderCMSBanners() }
            { /* { this.renderBanner() } */ }
            { /* { this.renderLastLine() } */ }
            { this.renderContent() }
            { isPLP ? this.renderPlpFooter() : null }
            <div block="DownFooter">
                <div block="DownFooter" elem="top">
                    <span>Contact</span>
                    <Link to="/">hello@zm.com</Link>
                    <Link to="#">|</Link>
                    <Link to="/">1800-267-4444</Link>
                </div>
                <div block="DownFooter" elem="bottom">
                    <span block="DownFooter" elem="left">© 2022 ZM Private Limited. All rights reserved.</span>
                    <div block="DownFooter" elem="right">
                        <Link to="/">Legal Stuff</Link>
                        <span>|</span>
                        <Link to="/">Privacy Pledge</Link>
                        <span>|</span>
                        <Link to="/">Terms of Service</Link>
                        <span>|</span>
                        <Link to="/">Accessibility</Link>
                        <span>|</span>
                        <Link to="/">Partners Program</Link>
                    </div>
                </div>
            </div>
            </>
        );
    }

    renderCMSContent() {
        const { device: { isMobile } } = this.props;
        if (isMobile) {
            setTimeout(() => {
                const footer_top = document.getElementById('footer_top');
                const footer_top_place = document.getElementById('footer_top_place');
                if (footer_top && footer_top_place) {
                    footer_top_place.innerHTML = footer_top.innerHTML;
                    footer_top.remove();
                }
            }, 1000);
        }

        return (
            <CmsBlock identifier="main_footer" />
        );
    }

    render() {
        const { device } = this.props;
        if (device.isMobile) {
            const { mobileFooterCollapse, onClickFooterAccordion } = this.props;
            return (
                <>
                <div id="footer_top_place" />
                <div block="Footer" elem="Mobile" mods={ { isOpen: mobileFooterCollapse } }>
                    { !mobileFooterCollapse && <style>{ '#main_footer { display: none; }' }</style> }
                    <div
                      block="Footer"
                      elem="MobileToggle"
                      onClick={ onClickFooterAccordion }
                      key="Footer-Toggle"
                    >
                        <span>More About Online Shopping at ZAYNMYZA</span>
                        <span block="Footer" elem="Caret" mods={ { isOpen: mobileFooterCollapse } }>
                        <svg width="14px" height="14px" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
                            <path fill="#fff" fill-rule="evenodd" d="M7.05307007,2.15808105 L14.2962587,9.41418482 C14.4320862,9.5496827 14.5,9.71077067 14.5,9.89744874 C14.5,10.0841268 14.4320862,10.2497803 14.2962587,10.3944092 C11.6760845,12.9498393 9.15095523,15.4168071 6.72087106,17.7953128 C6.5962677,17.912323 6.09560574,18.2032928 5.70989407,17.7705688 C5.3241824,17.3378448 5.55848694,16.9602509 5.70989407,16.8045692 C7.97174895,14.594209 10.3279004,12.2918355 12.7783485,9.89744874 L6.03100586,3.13816833 C5.78524099,2.79925826 5.80526899,2.48632792 6.09108986,2.19937732 C6.37691073,1.91242672 6.6975708,1.8986613 7.05307007,2.15808105 Z" />
                        </svg>
                        </span>
                    </div>
                    { this.renderCMSContent() }
                </div>
                </>
            );
        }

        return (
            <>
            { /* <CmsBlock identifier="footer_banners" /> */ }
            { this.renderCMSContent() }
            </>
        );
    }
}

export default FooterComponent;
